import apollo from '@/graphql'

import SaveWholesalerDetails from '@/graphql/wholesaler/SaveWholesalerDetails.gql'
import UploadWholesalerLogo from '@/graphql/wholesaler/UploadWholesalerLogo.gql'
import WholesalerDetailsQuery from '@/graphql/wholesaler/WholesalerDetailsQuery.gql'

// initial state
const state = {
  editableWholesalerFields: {},
  wholesalerDetails: {},
}

// getters
const getters = {
  editableWholesalerFields: st => st.editableWholesalerFields,
  wholesalerDetails: st => st.wholesalerDetails,
}

// mutations
const mutations = {
  createWholesalerDetails() {
    state.editableWholesalerFields = { companyType: 'wholesaler' }
    state.wholesalerDetails = { name: 'New Wholesaler' }
  },

  setEditableWholesalerFields(st, wholesalerDetails) {
    state.editableWholesalerFields = {
      id: wholesalerDetails.id,
      name: wholesalerDetails.name,
      phone: wholesalerDetails.phone,
    }
  },

  setWholesalerDetails(st, wholesalerDetails) {
    state.wholesalerDetails = wholesalerDetails
  },

  updateWholesalerFields(st, fields) {
    Object.assign(state.editableWholesalerFields, fields)
  },
}

// actions
const actions = {
  loadWholesalerDetails({ commit }, { id }) {
    apollo.defaultClient
      .watchQuery({
        fetchPolicy: 'network-only',
        query: WholesalerDetailsQuery,
        variables: { id: +id },
      })
      .subscribe(({ data: { wholesalerDetails } }) => {
        commit('setWholesalerDetails', wholesalerDetails)
        commit('setEditableWholesalerFields', wholesalerDetails)
      })
  },

  saveWholesalerDetails(context, { $message, $router }) {
    apollo.defaultClient
      .mutate({
        mutation: SaveWholesalerDetails,
        variables: { fields: state.editableWholesalerFields },
        refetchQueries: [state.wholesalerDetails.id].filter(id => id).map(id => ({
          query: WholesalerDetailsQuery,
          variables: { id },
        })),
      })
      .then(({ data: { saveCompanyDetails: { id } } }) => {
        $message({ message: 'Changes saved', type: 'success' })
        $router.push(`/wholesaler/${id}`)
      })
      .catch((err) => {
        $message.error(err.message)
      })
  },

  async uploadWholesalerLogo(context, { file }) {
    try {
      await apollo.defaultClient.mutate({
        mutation: UploadWholesalerLogo,
        variables: { id: state.wholesalerDetails.id, file },
        refetchQueries: [
          {
            query: WholesalerDetailsQuery,
            variables: { id: state.wholesalerDetails.id },
          },
        ],
      })
    } catch (err) {
      throw new Error(err.graphQLErrors[0].message)
    }
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/wholesaler/WholesalerDetails.js